export const NAV = {
  root: "main-nav",
  logo: "nav-logo",
  link: (k) => `nav-link-${k}`,
  cta: "nav-cta-book",
  mobileToggle: "nav-mobile-toggle",
  variantSwitch: (k) => `nav-variant-${k}`,
};

export const HERO = {
  root: "hero-section",
  video: "hero-video",
  scrollIndicator: "hero-scroll-indicator",
  stateHeadline: (i) => `hero-state-headline-${i}`,
  stateSub: (i) => `hero-state-sub-${i}`,
  scrubber: "hero-scrubber",
  reducedMotionImage: "hero-reduced-motion-image",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const SHIFT = { root: "shift-section" };
export const WHATWEDO = {
  root: "whatwedo-section",
  card: (k) => `whatwedo-card-${k}`,
};
export const WHYNOW = { root: "whynow-section" };
export const PLANS = {
  root: "plans-section",
  card: (k) => `plan-card-${k}`,
  cta: (k) => `plan-cta-${k}`,
};
export const PRIVACY = { root: "privacy-section" };
export const FAQ = {
  root: "faq-section",
  item: (k) => `faq-item-${k}`,
};
export const BOOKING = {
  root: "booking-section",
  form: "booking-form",
  name: "booking-name",
  email: "booking-email",
  company: "booking-company",
  industry: "booking-industry",
  message: "booking-message",
  submit: "booking-submit",
  success: "booking-success",
  error: "booking-error",
  fallbackLink: "booking-fallback-link",
};
export const STICKY = { root: "mobile-sticky", cta: "mobile-sticky-cta" };
export const FOOTER = {
  root: "footer",
  link: (k) => `footer-link-${k}`,
  cta: "footer-cta",
};
